"use client";

import { useTranslation } from "react-i18next";
import { SupportedCountries } from "@/enums/internationalization";
import { RecentCallData } from "@/types/notifications";
import { GetPhoneNumberForUI } from "@/utils/common/phone";
import { formatDateTimeDisplay } from "@/components/workflows/custom-nodes/delay/delayUtils";

type RecentCallNotificationProps = {
  data: RecentCallData;
  createdAt: string;
  country: SupportedCountries;
};

export default function RecentCallNotification({
  data,
  createdAt,
  country,
}: RecentCallNotificationProps) {
  const { t } = useTranslation("notifications");
  const phone =
    data.direction === "inbound"
      ? data.fromPhoneNumber
      : data.toPhoneNumber;
  const formattedPhone = GetPhoneNumberForUI(phone, country);
  const formattedDate = formatDateTimeDisplay(createdAt);
  const key =
    data.direction === "inbound"
      ? "recentCall.inbound"
      : "recentCall.outbound";
  const message = t(key, { phone: formattedPhone, date: formattedDate });
  return <span>{message}</span>;
}
